module.exports = __webpack_public_path__ + "img/squishie-angel.65c4fdc3.png";